import { render } from 'react-dom'
import { CookiesDisclaimer } from '../../Cookies/CookiesDisclaimer'

document.addEventListener('DOMContentLoaded', () => {
  render(
    <CookiesDisclaimer />,
    document.getElementById('cookies-disclaimer-privacy')
  )
})
